export const adminActionMigrations = [
  {
    id: '043_admin_work_schedule_and_action_notifications',
    sql: `
      ALTER TABLE platform_settings
        ADD COLUMN IF NOT EXISTS admin_work_timezone TEXT NOT NULL DEFAULT 'Europe/Berlin',
        ADD COLUMN IF NOT EXISTS admin_work_days SMALLINT[] NOT NULL DEFAULT ARRAY[1,2,3,4,5]::SMALLINT[],
        ADD COLUMN IF NOT EXISTS admin_work_start_minutes SMALLINT NOT NULL DEFAULT 540,
        ADD COLUMN IF NOT EXISTS admin_work_end_minutes SMALLINT NOT NULL DEFAULT 1020,
        ADD COLUMN IF NOT EXISTS sham_cash_review_minutes SMALLINT NOT NULL DEFAULT 10,
        ADD COLUMN IF NOT EXISTS sham_cash_after_open_minutes SMALLINT NOT NULL DEFAULT 60;

      ALTER TABLE platform_settings DROP CONSTRAINT IF EXISTS platform_settings_work_minutes_check;
      ALTER TABLE platform_settings ADD CONSTRAINT platform_settings_work_minutes_check CHECK (
        admin_work_start_minutes BETWEEN 0 AND 1438
        AND admin_work_end_minutes BETWEEN 1 AND 1439
        AND admin_work_start_minutes < admin_work_end_minutes
        AND sham_cash_review_minutes BETWEEN 1 AND 120
        AND sham_cash_after_open_minutes BETWEEN 1 AND 240
      );
      ALTER TABLE platform_settings DROP CONSTRAINT IF EXISTS platform_settings_work_days_check;
      ALTER TABLE platform_settings ADD CONSTRAINT platform_settings_work_days_check CHECK (
        cardinality(admin_work_days) BETWEEN 1 AND 7
        AND admin_work_days <@ ARRAY[1,2,3,4,5,6,7]::SMALLINT[]
      );

      CREATE TABLE IF NOT EXISTS admin_action_notification_receipts (
        admin_user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        action_key TEXT NOT NULL,
        delivered_at TIMESTAMPTZ,
        opened_at TIMESTAMPTZ,
        PRIMARY KEY (admin_user_id, action_key)
      );
    `,
  },
] as const;
